import apiClient from './apiClient';

/**
 * Service for Tower Light specific views.
 */
const towerLightService = {
    async getTowerLightStats() {
        return await apiClient.get('/stats/tower-light');
    },

    async getTowerLightDevices() {
        return await apiClient.get('/devices/category/tower-light');
    },

    async getDeviceById(deviceId) {
        return await apiClient.get(`/devices/${deviceId}/detail`);
    },

    async getDeviceHistory(deviceId, limit = 50) {
        return await apiClient.get(`/devices/${deviceId}/history`, { params: { limit } });
    },

    async sendCommand(deviceId, command, value) {
        return await apiClient.post(`/devices/${deviceId}/command`, { command, value });
    }
};

export default towerLightService;
